import { getAllVat } from '@/api/vat.api';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useVatStore } from '@/store/vat.store';
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';

export const VatServiceApi = () => {
	const setVatData = useVatStore(state => state.setVatData);
	const isAuthenticated = useIsAuthenticated();

	const { data, isLoading } = useQuery({
		queryKey: ['vat'],
		queryFn: () => getAllVat(),
		enabled: isAuthenticated,
		retry: isAuthenticated,
		refetchOnWindowFocus: true,
		staleTime: 1000 * 60,
		placeholderData: keepPreviousData,
	});

	useEffect(() => {
		if (!isAuthenticated || isLoading || !data) return;
		setVatData(data);
	}, [data, isAuthenticated, isLoading, setVatData]);

	return <></>;
};
